import Component from '@bythepixel/component-loader';

const INTERVAL = 5000;

export default class Background extends Component {
  static selector = '[data-comp-background-swap]';

  constructor(containerEl) {
    super(containerEl);
    this.images = this.$container.querySelectorAll('picture');
    this.currentImage = 0;
    this.initImageSwap();
  }

  initImageSwap() {
    setInterval(() => {
      // the current image has a style attribute with custom property set to --opacity: 1
      // all others have --opacity: 0
      this.currentImage = (this.currentImage + 1) % this.images.length;
      for (let i = 0; i < this.images.length; i++) {
        this.images[i].style.setProperty('--opacity', i === this.currentImage ? 1 : 0);
        this.images[i].setAttribute('aria-hidden', i !== this.currentImage);
      }
    }, INTERVAL);
  }
}
